import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'changeLogStatus',
    standalone: false
})
export class ChangeLogStatusPipe implements PipeTransform {
  constructor(private _translate: TranslateService) {}

  transform(changeLogStatusTypeId: number): string {
    if (!changeLogStatusTypeId) {
      return null;
    }

    let message: string;
    switch (changeLogStatusTypeId) {
      case 1: {
        message = this._translate.instant('NOTIFICATION.ADD');
        break;
      }
      case 2: {
        message = this._translate.instant('NOTIFICATION.DEACTIVATED');
        break;
      }
      case 3: {
        message = this._translate.instant('NOTIFICATION.CHANGED');
        break;
      }
      case 4: {
        message = this._translate.instant('NOTIFICATION.NOT_YET_ACTIVATED');
        break;
      }
      case 5: {
        message = this._translate.instant('NOTIFICATION.REACTIVATED');
        break;
        }
      case 12: {
            message = this._translate.instant('NOTIFICATION.SCALING_CHANGED');
        break;
      }
    }
    return message;
  }
}
